<!--
  @NavButton  Button in a module navigation bar (Breadcrumbs), styled like the buttons of the Sidebar:
  icon above a short label.
-->

<script>
		let {icon, label, title = null, active = false, ...rest} = $props()
</script>


<button class="navBtn" class:active title={title ?? label} {...rest}>
	<i class="fa icon-{icon}"></i>
	<span>{label}</span>
</button>


<style lang="sass">
	@use "../colors" as colors

	.navBtn
		flex: none
		min-width: 64px
		display: flex
		flex-direction: column
		align-items: center
		gap: 3px
		margin: 0
		padding: 5px 6px 4px
		border: 0
		border-radius: 8px
		background: transparent
		color: colors.$grey-85
		font-size: 11px
		line-height: 1.2
		text-align: center
		white-space: nowrap
		cursor: pointer

		.fa
			font-size: 20px

		&:hover:not(:disabled)
			background: rgba(255, 255, 255, 0.07)
			color: colors.$white

		&.active
			background: colors.$primary-080-black
			color: colors.$white

		&:disabled
			opacity: 0.4
			cursor: default

		&:focus-visible
			outline: 2px solid colors.$primary-100
			outline-offset: 2px
</style>
